import { toFormData } from "axios";
import instance from "../config";

const getAgenda = async (params) => {
  try {
    const response = await instance.get("/api/agenda", { params });
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

const postAgenda = async (data) => {
  try {
    const response = await instance.post("/api/agenda", data);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
//---------------------//
//------Agregar-------//
//---------------------//
const postActividades = async (data) => {
  try {
    const response = await instance.post("/api/actividades", data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        success: false,
        msg: "Error de servidor al guardar actividad",
      }
    );
  }
};

const deleteAgenda = async (id) => {
  try {
    const response = await instance.delete(`/api/agenda/${id}`);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

const deleteActividad = async (id) => {
  try {
    const response = await instance.delete(`/api/actividades/${id}`);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// metodo para editar agenda
const putAgenda = async (id, data) => {
  try {
    const response = await instance.put(`/api/agenda/${id}`, data); // ⚡ no lo envíes como { data }
    return response.data;
  } catch (error) {
    console.error("Error en putAgenda:", error);
    return error.response?.data || { success: false, msg: "Error en servidor" };
  }
};

// metodo para editar actividades
const putActividades = async (id, data) => {
  try {
    const response = await instance.put(`/api/actividades/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error en putActividades:", error);
    return error.response?.data || { success: false, msg: "Error en servidor" };
  }
};

// metodo para obtener una Agenda
const getAgendaId = async (id, params) => {
  try {
    const response = await instance.get(`/api/agenda/${id}`, { params });
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

// ✅ Obtener actividades de una agenda
const getActividadesByAgenda = async (id, params) => {
  try {
    const response = await instance.get(`/api/agenda/${id}/actividades`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};


// me leer todas las actividades caducadas 
const getActividadesCaducadas = async () => {
  try {
    const response = await instance.get(`/api/abiertas/actividades`);
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

// Metodo para logearse a las notas privadas
const loginNotasPrivadas = async (id, pin) => {
  try {
    const response = await instance.post(`/auth/login/pin`, { id, pin });
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export {
  postAgenda,
  getAgenda,
  postActividades,
  deleteAgenda,
  putActividades,
  putAgenda,
  getAgendaId,
  deleteActividad,
  getActividadesByAgenda,
  getActividadesCaducadas,
  loginNotasPrivadas
};
